<template>
  <div>
    <div class="pos-relative" ref="item_cnt">
      <!-- <div v-if="force && $store.state.app.activeGroup.id == 9254"> -->
        <div v-if="!hideDownload && force && hasPermission(['admin', 'learningadmin'])">
          <!-- Сертификат загвар татах үед ашиглаж байгаа -->
        <!-- <a >татах</a> -->
          <div class="bg-white pd-10 bd-b"><button class="btn btn-outline-success btn-xs" @click="download"><i class="icon ion-md-download tx-14 mg-r-5 pd-t-5"></i> татах</button></div>
        </div>
      <loader
        ref="mediaLdr"
        :key="loaderKey"
        v-if="docExt != ''"
        :otCompName="docExt"
        :propFileId="parseInt(id, 0)"
        :prms="prms"
        :minusHeight="force && minusHeight == 170 ? 0 : minusHeight"
        @on-completed-info="$emit('on-completed-info', $event)"
        @on-img-loaded="onImgLoaded"
        @on-finish-video="$emit('on-finish-video', $event)"
        @on-hide-finish-btn="$emit('on-hide-finish-btn', $event)"
        :force="force"
        @on-interactive-media="$emit('on-interactive-media', $event)"
        @on-interactive-html="$emit('on-interactive-html', $event)"
      />
      <div
        v-if="$store.state.app.isMobile"
        style="position: absolute; top: 10px; right: 10px"
        class="bg-white pd-1 bd rounded-1"
      >
        <img class="wd-40 ht-40" :src="`data:image/png;base64, ${qrImg}`" />
      </div>
      <div v-else>
        <div
          v-if="docExt == 'image'"
          :style="`position: absolute; bottom: 30px; left: ${qrLeft}px`"
          class="bg-white pd-5 bd rounded-3"
        >
          <img class="wd-60 ht-60" :src="`data:image/png;base64, ${qrImg}`" />
        </div>
        <div
          v-else
          style="position: absolute; bottom: 80px; right: 30px"
          class="bg-white pd-5 bd rounded-3"
        >
          <img class="wd-60 ht-60" :src="`data:image/png;base64, ${qrImg}`" />
        </div>
      </div>
    </div>
    <div
      v-if="showDescr()"
      class="pd-x-10 pd-y-15 tx-13 tx-color-02"
      v-html="fileInf.desc"
    ></div>
    <img id="imgtmp" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getFileMode } from "@/libs/tools";
import { filePreData, filePreviewDetail } from "@/api/media";
import { hasOneOf } from "@/libs/tools";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";

export default {
  name: "FileDetail",
  components: {
    loader: () => ({
      component: import("@/components/modules/media/components/loader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    swd: {
      type: String,
      default: () => "90vw"
    },
    id: {
      type: [Number, String],
      default: () => 0
    },
    show: {
      type: Boolean,
      default: () => false
    },
    params: {
      type: Object,
      default: () => {}
    },
    hideDownload:{
      type: Boolean,
      default: () => false
    },
    force: {
      type: Boolean,
      default: () => false
    },
    minusHeight: {
      type: Number,
      default: () => 170
    }
  },
  data() {
    return {
      docExt: "",
      fileInf: {},
      prms: {},
      loaderKey: 0,
      showSidebar: false,
      qrImg: "",
      qrLeft: 0,
      img: { w: 600, h: 480 },
      
    };
  },
  mounted() {
    if (this.id > 0) this.fileDetail();
    if(this.params!=undefined && this.params.isFull!=undefined && this.params.isFull){
      this.prms.isFull= true;
    }
  },
  methods: {
    hasOneOf(tarr, arr) {
      return hasOneOf(tarr, arr);
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    ...mapActions(["handleLoading"]),
    playerResume(){
      this.$refs.mediaLdr.playerResume();
    },
    fileDetail() {
      this.showSidebar = true;

      let _prms = {};
      if (this.force) {
        _prms = {
          id: this.id
        };
      } else {
        _prms = {
          id: this.id,
          lessonId: this.params.id,
          courseId: this.params.cid,
          boxId: this.params.bid,
          objectTypeId: this.params.bot
        };
      }
      //console.log('filePreData', _prms);
      filePreData({
        params: _prms,
        store: this.$store
      }).then(res => {
        // console.log('filePreData', res);
        if (res != false) {
          //console.log(res);
          this.$emit("on-completed-info", res.data.isCompleted);
          
          // console.log('getFileMode(res.data.file.extension)', getFileMode(res.data.file.extension))
          
          //GOLOMT PDF TATAAD NUHTSUL AVAV 2021-09-22
          if (
            (
              // this.$store.state.app.activeGroup.id == 9132 ||  
              // this.$store.state.app.activeGroup.id == 9352 || 
              this.$store.state.app.activeGroup.id == 9241 ||
              this.$store.state.app.activeGroup.id == 9249) &&
            getFileMode(res.data.file.extension) == "pdfObject"
          ) {
            //# pdf olgoj baisniig tataad bsn uchir document bolgov golomt 2021-09-30
            this.docExt = "document";
          }
          //  else if(this.$store.state.app.activeGroup.id == 9132 && getFileMode(res.data.file.extension) == "pdfObject"){
          //   this.docExt = "pdf";
          // }
           else if((this.$store.state.app.activeGroup.id == 9357 
          //|| this.$store.state.app.activeGroup.id == 9352

          ) && (
            res.data.file.extension=='ppt' ||
            res.data.file.extension=='pptx'
          )){
            // console.log('getFileMode(res.data.file.extension', getFileMode(res.data.file.extension), res.data.file.extension)
            this.docExt = "ppt";
          }
          // else if(this.$store.state.app.activeGroup.id == 9157){
          //   if(getFileMode(res.data.file.extension) == "pdfObject"){
          //     this.docExt = "pdf";
          //   }
          //   // console.log('getFileMode(res.data.file.extension)', getFileMode(res.data.file.extension))
          // } 
          // else if(getFileMode(res.data.file.extension) == "video"){
          //   this.fetchInteractives(this.id);
          // }
          else if(getFileMode(res.data.file.extension) == "pdfObject"){
            this.docExt = "pdfJs";
          }
          else {
            //console.log('getFileMode(res.data.file.extension)', getFileMode(res.data.file.extension), res.data.file.extension)
            this.docExt = getFileMode(res.data.file.extension);
          }

          //this.docExt = getFileMode(res.data.file.extension);

          this.loaderKey++;
          filePreviewDetail({
            params: { id: this.id },
            store: this.$store
          }).then(res => {
            //console.log('filePreviewDetail', res);
            if (res != false) {
              this.$emit("on-data-fetched", res);
              //console.log(res);
              this.generateQr();

              if (
                this.docExt == "document" ||
                this.docExt == "pdfObject" ||
                this.docExt == "pdf" ||
                this.docExt == "pdfJs" ||
                this.docExt == "ppt"
              ) {
                this.$emit("content-no-padding", true);
              } else this.$emit("content-no-padding", false);

              this.$emit("on-file-loaded", res.data.file);
              this.fileInf = res.data.file;
              if (!this.force) this.updateRecentView();
            }
          });
        }
      });
    },
    
    generateQr() {
      let grpLatinName = this.$store.state.app.activeGroup.id;
      if (
        this.$store.state.app.activeGroup.id == 9241 ||
        this.$store.state.app.activeGroup.id == 9249
      )
        grpLatinName = "Golomt";
      request({
        api: { method: "POST", url: "Qr/Generate" },
        data: {
          qr: `${grpLatinName}-${this.$store.state.user.userInfo.user_name}`
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.qrImg = res.data.base64;
        }
      });
    },
    visibleChanged(e) {
      if (!e) {
        //this.loaderKey++;
        this.showSidebar = false;
        this.$emit("on-hide");
      }
    },
    updateRecentView() {
      request({
        api: { method: "POST", url: "Learn/AttachFinish" },
        data: {
          attachId: this.params.iid,
          lessonId: this.params.id,
          courseId: this.params.cid,
          boxId: this.params.bid,
          objectTypeId: this.params.bot,
          isCompleted: false
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.$emit("on-finished", this.params);
          //console.log('AttachFinish=> ', res);
        }
      });
    },
    download(){
      window.open(
            this.fileInf.link + "?i=" + Math.floor(Math.random() * 100),
            "_blank"
          );
    },
    showDescr() {
      if (
        getFileMode(this.docExt) != "document" &&
        getFileMode(this.docExt) != "pdfObject" &&
        this.fileInf.desc != null &&
        this.fileInf.desc != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    onImgLoaded(e) {
      let self = this;
      var img = document.createElement("img");
      img.src = e.link + "?w=1200";
      img.onload = function() {
        //console.log(self.$refs['item_cnt'].clientWidth);
        //   div w = 1200
        // img w = 400
        // (1200-400)%2+30
        // ----****----
        if (img.naturalWidth >= self.$refs["item_cnt"].clientWidth) {
          self.qrLeft = 30;
        } else
          self.qrLeft =
            (self.$refs["item_cnt"].clientWidth - img.naturalWidth) / 2 + 30;
      };
    }
  },
  computed: {
    courseid() {
      return this.show;
    }
  },
  watch: {
    courseid(val) {
      if (val) {
        this.fileDetail();
      }
    }
  }
};
</script>
